<ng-content select=".customer-site-intro-image-controls"></ng-content>

<div
    class="customer-site-intro-container"
    [class.customer-site-intro-container--with-bg]="site.siteIntro['backgroundImage']"
    [ngStyle]="getBackgroundColorStyle()"
>
    <div class="customer-site-intro-section">
        <div>
            <div *ngIf="site['theme']['logo'] && showLogo" id="customer-site-intro-logo">
                <a *ngIf="site.settings.homepageUrl" [href]="site.settings.homepageUrl" target="_blank">
                    <img [src]="site['theme']['logo']['url']" [alt]="site['theme']['logo']['altText']">
                </a>
                <img *ngIf="!site.settings.homepageUrl" [src]="site['theme']['logo']['url']" [alt]="site['theme']['logo']['altText']">
                <div *ngIf="!isReadOnly && site.settings.homepageUrl" class="logo-homepage-link">
                    <div class="link-icon"><i class="icon icon-link"></i></div>
                    <div class="link-hover">{{ site.settings.homepageUrl }}</div>
                </div>
            </div>
        </div>

        <div *ngIf="site['siteIntro']['html']">
            <div id="customer-site-intro-copy">
                <ng-content select=".customer-site-intro-copy"></ng-content>
            </div>
        </div>
    </div>
</div>
